function getPurchaseTypes(purchaseTypeContainer) {
  if (!purchaseTypeContainer) {
    return void 0;
  }
  return {
    title: !!purchaseTypeContainer.title ? purchaseTypeContainer.title : void 0,
    purchaseTypes: purchaseTypeContainer.purchaseType.map((purchaseType) => ({
      title: purchaseType.title,
      key: purchaseType.key,
      description: !!purchaseType?.description?.value ? purchaseType.description.value : void 0,
      badgeText: !!purchaseType.badgeText ? purchaseType.badgeText : void 0
    }))
  };
}
export {
  getPurchaseTypes
};
//# sourceMappingURL=get-purchase-types.js.map
